<script lang="ts">
  import { Button } from '@squareup/public-web-design-system';
  import type { SelectionEmitterTabsProps } from './types';
  import type { SelectionState } from '../SelectionContainer/types';
  import { type Writable } from 'svelte/store';
  import { getContext } from 'svelte';

  export let entryId: SelectionEmitterTabsProps['entryId'];
  export let customCssClass: SelectionEmitterTabsProps['customCssClass'];
  export let tabs: SelectionEmitterTabsProps['tabs'];

  const selectionState: Writable<SelectionState> = getContext('selectionState');
  $selectionState.selectedKey = 'item-1';

  function handleTabClick(key: string): void {
    $selectionState.selectedKey = key;
  }
</script>

<div
  class="SelectionEmitterTabs SelectionEmitterTabs-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
>
  {#each tabs as tab}
    <Button
      size="small"
      variant={tab.key === $selectionState.selectedKey ? 'button' : 'button-alt'}
      text={tab.label}
      onClick={() => handleTabClick(tab.key)}
    />
  {/each}
</div>

<style lang="scss">
  .SelectionEmitterTabs {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
</style>
